import dayjs from 'dayjs';

export interface CustomValidationError {
  message: string;
  instancePath: string;
}

export function validateAndEnrich(
  data: any,
  schema: any,
): { enrichedData: any; customErrors: CustomValidationError[] } {
  if (!data) return { enrichedData: data, customErrors: [] };

  const customErrors: CustomValidationError[] = [];
  let enrichedData = { ...data };

  // Lease date range validation
  if (data.leaseStartDate && data.leaseEndDate) {
    const start = dayjs(data.leaseStartDate);
    const end = dayjs(data.leaseEndDate);

    if (end.isBefore(start) || end.isSame(start)) {
      customErrors.push({
        message: 'Lease end date must be after start date',
        instancePath: '/leaseEndDate',
      });
    }

    // Auto-calculate lease term in months
    if (start.isValid() && end.isValid() && end.isAfter(start)) {
      enrichedData.leaseTermMonths = end.diff(start, 'month');
    }
  }

  return { enrichedData, customErrors };
}
